import * as ApiManager from './_manager'
import store from '../store';

export const plan = {
    getPlans: (payload) => {
        return ApiManager.callApi ( `/guest/company/${store.getters['company/getCurrentCompanyId']}/pricing/listPlans`, payload);
    },
}
